/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_0fe8f248"]'><div :class='["checkbox-group-square-column-num-demo"]'><div :class='["cube-checkbox-group-example"]'><cube-checkbox-group :options="(options)" shape="square" :colNum="(3)" :values="checkedValues" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkedValues", "__mpx_event__", ["value"], undefined]])'></cube-checkbox-group></div><div :class='["view-desc"]'>checked values：{{ checkedValues }}</div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_0fe8f248"}'>
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_0fe8f248"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_0fe8f248"}
  /** script content **/
  require("./square-column-num.mpx.js?isComponent&outputPath=components%2Fsquare-column-num0fe8f248%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./square-column-num.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fsquare-column-num0fe8f248%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_0fe8f248"],
    ctorType: "component",
    outputPath: "components/square-column-num0fe8f248/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-checkbox-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox-group/index.mpx?isComponent&outputPath=components%2Findexc8b9c288%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>